import { all, call, fork, takeEvery, put, takeLatest, select } from "redux-saga/effects";
import { ADD_UPDATE_TEMPLATE, GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES, GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_ERROR, GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_SUCCESS, GET_ALL_PUBLIC_TEMPLATES, GET_ALL_PUBLIC_TEMPLATES_ERROR, GET_ALL_PUBLIC_TEMPLATES_SUCCESS, GET_TEMPLATES } from "../../appRedux/actions/templatesAction";
import { fetchTemplatesRequestAPI, fetchAllPublicTemplatesRequestAPI, fetchAllCategorizedPublicMacrosAPI, deleteMacroAPI, fetchAllGroupMacrosAPI, addUpdatePrivateTemplateAPI, addUpdateGroupTemplateAPI, fetchAllCategorizedGroupTemplatesAPI, fetchAllGroupTemplatesAPI, deleteTemplateAPI, deleteGroupTemplateAPI, fetchAllCategorizedPublicTemplatesAPI, deletePrivateTemplateAPI } from '../../services/template-service';
import { addUpdateTemplateSuccess, getTemplatesSuccess, addUpdateGroupTemplateSuccess, } from '../../appRedux/actions/templatesAction';
import { message } from "antd";
import _ from 'lodash';
import { GET_ALL_GROUP_TEMPLATES_ERROR, GET_ALL_GROUP_TEMPLATES_SUCCESS, GET_ALL_GROUP_TEMPLATES, ADD_UPDATE_GROUP_TEMPLATE, GET_ALL_CATEGORIZED_GROUP_TEMPLATES_SUCCESS, GET_ALL_CATEGORIZED_GROUP_TEMPLATES, DELETE_GROUP_TEMPLATE, DELETE_TEMPLATE, DELETE_TEMPLATE_ERROR, DELETE_TEMPLATE_SUCCESS, DELETE_GROUP_TEMPLATE_SUCCESS, DELETE_GROUP_TEMPLATE_ERROR } from '../../appRedux/actions/templatesAction';

const getTemplates = state => { return state.templates.templates };
const getGroupTemplates = state => { return state.templates.groupTemplates };

const getGroups = state => { return state.groups.groups };

function* fetchTemplates({ payload }) {

    try {
        const response = yield call(fetchTemplatesRequestAPI, payload.userId);

        if (response.success) {
            yield put(getTemplatesSuccess(response.data));
        }
    } catch (error) {
        // yield put(showVisitsMessage(error));
    }
}

function* addUpdateTemplate({ payload }) {

    try {
        const response = yield call(addUpdatePrivateTemplateAPI, payload.template);

        if (response.success) {
            yield put(addUpdateTemplateSuccess(response.data));
            if (payload.template.id === 0) {
                message.success('Added template successfully.');
            } else {
                message.success('Updated template successfully.');
            }

        } else {
            if (payload.template.id === 0) {
                if (response.error.response.data === "Template already exists with the same name or value!") {
                    message.error("Template already exists with the same name or value!");
                } else {
                    message.error("Failed to add template!");
                }

            } else {
                if (response.error.response.data === "Template already exists with the same name or value!") {
                    message.error("Template already exists with the same name or value!");
                } else {
                    message.error('Failed to update template!');
                }

            }
        }
    } catch (error) {

        // yield put(showVisitsMessage(error));
    }
}



function* addUpdateGroupTemplate({ template }) {

    try {
        const response = yield call(addUpdateGroupTemplateAPI, template);

        if (response.success) {

            const groups = yield select(getGroups);

            var groupName = groups.find(groupItem => groupItem.groupId === response.data.groupId)

            var modifiedData = response.data;

            if (groupName) {
                modifiedData.groupName = groupName.name;
            }

            yield put(addUpdateGroupTemplateSuccess(modifiedData));
            if (template.id === 0) {
                message.success('Added template successfully.');
            } else {
                message.success('Updated template successfully.');
            }

        } else {
            if (template.id === 0) {
                if (response.error.response.data === "Template already exists with the same name or value!") {
                    message.error("Template already exists with the same name or value!");
                } else {
                    message.error("Failed to add template!");
                }

            } else {
                if (response.error.response.data === "Template already exists with the same name or value!") {
                    message.error("Template already exists with the same name or value!");
                } else {
                    message.error('Failed to update template!');
                }

            }
        }
    } catch (error) {

        // yield put(showVisitsMessage(error));
    }
}


function* getAllPublicTemplates({ }) {

    try {
        const response = yield call(fetchAllPublicTemplatesRequestAPI);
        if (response.success) {
            yield put({ type: GET_ALL_PUBLIC_TEMPLATES_SUCCESS, publicTemplates: response.data })
        }
    } catch (error) {

        yield put({ type: GET_ALL_PUBLIC_TEMPLATES_ERROR, error: error })
    }
}

function* getAllCategorizedPublicTemplates({ }) {

    try {
        const response = yield call(fetchAllCategorizedPublicTemplatesAPI);

        if (response.success) {
            yield put({
                type: GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_SUCCESS, categorizedPublicTemplates: _.cloneDeep(response.data)
            })
        } else {
            message.error('Failed to fetch public templates!');
            yield put({ type: GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_ERROR });
        }
    } catch (error) {
        yield put({ type: GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES_ERROR, error: error })
    }
}

function* deletePrivateTemplate({ payload }) {
    try {
        let response = yield call(deletePrivateTemplateAPI, payload.template);
        const templates = yield select(getTemplates);


        if (response.success) {
            let filteredMacros = [];
            filteredMacros = templates.filter(template => template.id !== payload.template.id);


            yield put({
                type: DELETE_TEMPLATE_SUCCESS, templates: filteredMacros.length > 0 ? [...filteredMacros] : []
            })
            message.success('Deleted template successfully.');
        } else {
            message.error('Failed to delete template!');
            yield put({ type: DELETE_TEMPLATE_ERROR });
        }
    }
    catch (error) {
        message.error('Failed to delete template!');
        yield put({ type: DELETE_TEMPLATE_ERROR, error: error });
    }
}


function* deleteGroupTemplate({ payload }) {
    try {
        let response = yield call(deleteGroupTemplateAPI, payload.template);
        const groupTemplates = yield select(getGroupTemplates);


        if (response.success) {
            let filteredGroupTemplates = [];
            filteredGroupTemplates = groupTemplates.filter(groupTemplate => groupTemplate.id !== payload.template.id);

            yield put({
                type: DELETE_GROUP_TEMPLATE_SUCCESS, groupTemplates: filteredGroupTemplates.length > 0 ? [...filteredGroupTemplates] : []
            })
            message.success('Deleted template successfully.');
        } else {
            message.error('Failed to delete template!');
            yield put({ type: DELETE_GROUP_TEMPLATE_ERROR });
        }
    }
    catch (error) {
        message.error('Failed to delete template!');
        yield put({ type: DELETE_GROUP_TEMPLATE_ERROR, error: error });
    }
}

function* fetchAllGroupTemplates({ }) {

    try {
        const response = yield call(fetchAllGroupTemplatesAPI);

        if (response.success) {
            yield put({
                type: GET_ALL_GROUP_TEMPLATES_SUCCESS, groupTemplates: _.cloneDeep(response.data)
            })
        } else {
            message.error('Failed to fetch group templates!');
            yield put({ type: GET_ALL_GROUP_TEMPLATES_ERROR });
        }
    } catch (error) {
        yield put({ type: GET_ALL_GROUP_TEMPLATES_ERROR, error: error })
    }
}

function* fetchAllCategorizedGroupTemplates({ }) {

    try {
        const response = yield call(fetchAllCategorizedGroupTemplatesAPI);

        if (response.success) {
            yield put({
                type: GET_ALL_CATEGORIZED_GROUP_TEMPLATES_SUCCESS, categorizedGroupTemplates: _.cloneDeep(response.data)
            })
        } else {
            message.error('Failed to fetch group templates!');
            yield put({ type: GET_ALL_GROUP_TEMPLATES_ERROR });
        }
    } catch (error) {
        yield put({ type: GET_ALL_GROUP_TEMPLATES_ERROR, error: error })
    }
}

export function* getTemplatesWatcher() {
    yield takeEvery(GET_TEMPLATES, fetchTemplates);
}

export function* addUpdateTemplatesWatcher() {
    yield takeLatest(ADD_UPDATE_TEMPLATE, addUpdateTemplate);
}

export function* getAllPublicTempalteWatcher() {
    yield takeEvery(GET_ALL_PUBLIC_TEMPLATES, getAllPublicTemplates);
}

export function* getAllCategorizedTemplates() {
    yield takeEvery(GET_ALL_CATEGORIZED_PUBLIC_TEMPLATES, getAllCategorizedPublicTemplates)
}

export function* getAllGroupTemplatesWatcher() {
    yield takeLatest(GET_ALL_GROUP_TEMPLATES, fetchAllGroupTemplates)
}
export function* getAllCategorizedGroupTemplateWatcher() {
    yield takeLatest(GET_ALL_CATEGORIZED_GROUP_TEMPLATES, fetchAllCategorizedGroupTemplates)
}
export function* addUpdateGroupTemplateWatcher() {
    yield takeLatest(ADD_UPDATE_GROUP_TEMPLATE, addUpdateGroupTemplate)
}

export function* deletePrivateTemplateWatcher() {
    yield takeLatest(DELETE_TEMPLATE, deletePrivateTemplate)
}
export function* deleteGroupTemplateWatcher() {
    yield takeLatest(DELETE_GROUP_TEMPLATE, deleteGroupTemplate)
}


export default function* rootSaga() {
    yield all([fork(getTemplatesWatcher),
    addUpdateTemplatesWatcher(),
    getAllPublicTempalteWatcher(),
    getAllCategorizedTemplates(),
    deletePrivateTemplateWatcher(),
    deleteGroupTemplateWatcher(),
    getAllGroupTemplatesWatcher(),
    getAllCategorizedGroupTemplateWatcher(),
    addUpdateGroupTemplateWatcher()
    ]);
}